import { useAppStore } from "@/stores/appStore";
import { type_e, type_b, type_c, type_a, type_d } from "@/theme/typography";
import { useEffect, useState } from "react";
import styled from "styled-components";

export default function Input({
	title,
	minVal,
	maxVal,
	defaultVal,
	step,
	id,
	stateKey,
	stateType,
	updateLinkedValue,
	linkedValue,
}) {
	const [currentVal, setCurrentVal] = useState(defaultVal);

	const handleInput = (e: any) => {
		let value = 0;

		if (!e.target.value) {
			value = 150;
		} else {
			value = parseFloat(e.target.value);

			if (value < minVal) {
				value = minVal;
				setCurrentVal(minVal);
				updateLinkedValue([id, defaultVal]);
				return;
			}

			if (value > maxVal) {
				value = maxVal;
				setCurrentVal(maxVal);
				updateLinkedValue([id, defaultVal]);
				return;
			}
		}

		setCurrentVal(value);

		const options = (prevState) => ({
			...prevState.configurator,
			[stateKey]: {
				...prevState.configurator[stateKey],
				[stateType]: {
					...prevState.configurator[stateKey][stateType],
					[id]: value,
				},
			},
		});

		useAppStore.setState((prevState) => ({
			configurator: options(prevState),
		}));
	};

	const handleIncrement = () => {
		const newValue = Math.min(currentVal + step, maxVal);
		handleInput({ target: { value: newValue } });
		updateLinkedValue([id, defaultVal]);
	};

	const handleDecrement = () => {
		const newValue = Math.max(currentVal - step, minVal);
		handleInput({ target: { value: newValue } });
		updateLinkedValue([id, defaultVal]);
	};

	const handleOnChange = (id, value) => {
		setCurrentVal(value);
		updateLinkedValue([id, defaultVal]);
	};

	useEffect(() => {
		if (linkedValue && linkedValue.id === id) {
			setCurrentVal(linkedValue.value);
		}
	}, [linkedValue]);

	return (
		<ContainerItems>
			<div className="input__wrapper">
				<div className="input__header">
					<p className="item__title" style={type_c}>
						{title}
					</p>
					<div className="input__meta">
						<span>{minVal}cm</span> - <span>{maxVal}cm</span>
					</div>
				</div>
				<div className="input__control">
					<input
						style={type_c}
						type="number"
						id="length"
						name="length"
						step={step}
						value={currentVal}
						onChange={(e) => handleOnChange(id, parseFloat(e.target.value))}
						onBlur={(e) => handleInput(e)}
					/>
					<button className="control__btn" onClick={handleDecrement}>
						-
					</button>
					<button className="control__btn" onClick={handleIncrement}>
						+
					</button>
				</div>
			</div>
		</ContainerItems>
	);
}

const ContainerItems = styled.div`
	.input__wrapper {
		display: flex;
		flex-direction: column;
		justify-content: space-between;
	}

	.input__header {
		display: flex;
		justify-content: space-between;
	}

	.item__title {
		color: rgb(112, 112, 112);
	}

	.input__control {
		display: flex;
		align-items: center;
		padding-block: 0.3rem;
		padding-inline: 5px;
		border-radius: 5px;
		border: 2px solid #d5ccc8;
		margin-block: 0.3rem;
		column-gap: 5px;

		input {
			background-color: rgba(0, 0, 0, 0);
			border: none;
			width: 100%;
			color: ${({ theme }) => theme.colors.secondary};

			&:focus {
				outline: none;
			}
		}
	}

	.input__control:has(input:focus) {
		border: 2px solid ${({ theme }) => theme.colors.secondary};
	}

	.control__btn {
		width: 40px;
		height: 30px;
		border: none;
		border-radius: 5px;
		background-color: #d5ccc8;
		cursor: pointer;

		&:hover {
			background-color: ${({ theme }) => theme.colors.secondary};
		}
	}

	.input__meta {
		color: rgb(126, 112, 108);
		display: flex;
		column-gap: 5px;
		font-size: 0.75rem;
		font-family: Inter;
	}

	input[type="number"] {
		-moz-appearance: textfield;
		&::-webkit-outer-spin-button,
		&::-webkit-inner-spin-button {
			-webkit-appearance: none;
			margin: 0;
		}
	}
`;
